export const systemFont = `-apple-system, system-ui`;
export const interFont = `Inter, ${systemFont}`;

export default {
  inter: interFont,
  system: systemFont,
};
